import React, { createContext, Dispatch, ReactChild, ReactChildren, SetStateAction, useEffect, useState } from 'react'
import { Visite } from '../types/VisitesTypes'
import { getVisitesList } from '../api/visitesApi'
import { TYPE_MODAL_VISITE } from '../enums/typeModalVisite'

export type VisiteConcerneeType = any
interface VisiteConcerneeModel {
	offre: VisiteConcerneeType,
	typeModal: TYPE_MODAL_VISITE
}

export interface VisiteContextProps {
	incomingVisits: Visite[]
	setIncomingVisits: Dispatch<SetStateAction<Visite[]>>,
	setIsLoadingVisits: Dispatch<SetStateAction<boolean>>,
	isLoadingVisits: boolean
}

export const VisiteContext = createContext<VisiteContextProps>({
	incomingVisits: [],
	isLoadingVisits: false,
	setIncomingVisits: (visits) => {},
	setIsLoadingVisits: () => {},
})

interface VisiteProviderProps {
	children: ReactChild | ReactChildren
}

export const VisiteProvider: React.FC<VisiteProviderProps> = ({ children }) => {
	const [incomingVisits, setIncomingVisits] = useState<Visite[]>([])
	const [isLoadingVisits, setIsLoadingVisits] = useState<boolean>(true)

	useEffect(() => {
		getVisitesList(false)
			.then((response: any) => {
				setIncomingVisits(response.visites.filter((it: Visite) => !it.isEdle || it.isEdle === null))
			})
			.finally(() => setIsLoadingVisits(false))
	}, [])

	return (
		<VisiteContext.Provider
			value={{
				incomingVisits,
				setIncomingVisits,
				setIsLoadingVisits,
				isLoadingVisits
			}}
		>
			{children}
		</VisiteContext.Provider>
	)
}